import { Plus } from 'lucide-react';
import React, { useEffect, useState } from 'react';
// import './patientList.css'
import {
    Button,
    ButtonGroup,
    Card,
    Col,
    Container,
    Form,
    Image,
    Modal,
    Row,
    Spinner,
    Stack,
    Table,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useEditUserMutation } from '../Patient/patientApi';
import { formatDate } from '../../helper';
import { usePosAddMutation } from './posApi';

const AddPos = ({ setLoading, edit, setEdit }) => {
    const config = {
        email: '',
        password: 'SymInfo2024',
        mobile: '',
        userType: 'OPTICIAN',
        languageId: 1,
        name: '',
        lastName: '',
        dateOfBirth: '',
        doYouWearGlasses: true,
        whenIsTheLastTimeYouWentToTheEyeDoctor: '',
        patientNameOfYourUsualEyeDoctor: '',
        patientRppsNumberOfYourUsualEyeDoctor: 0,
        phoneNumber: 0,
        typeOfVision: '',
        patientHappy: '',
        patientSymptoms: '',
        patientDiagnosedWith: '',
        patientHealthConditions: '',
        additionalComments: '',
        doctorRppsNumber: '',
        doctorIdOfRegistration: '',
        doctorAddressOfTheHealthCenter: '',
        SubmitTrack: 'Web',
    };
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [opticianConfig, setOpticianConfig] = useState(config);
    const [inputStatus, setInputStatus] = useState({
        name: false,
        email: false,
        mobile: false,
        additionalComments: false,
    });
    const [addPos] = usePosAddMutation();
    const [editPos] = useEditUserMutation();

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setOpticianConfig((prevValues) => {
            return {
                ...prevValues,
                [name]: value,
            };
        });

        setInputStatus((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    useEffect(() => {
        console.log(edit, 'editeditedit');
        if (Object.keys(edit).length > 0) {
            setShow(true);
            setOpticianConfig(() => {
                return {
                    ...edit,
                    dateOfBirth: formatDate(edit.dateOfBirth),
                };
            });
        }
    }, [edit]);

    useEffect(() => {
        console.log(opticianConfig, 'opticianConfigopticianConfig');
    }, [opticianConfig]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (
            opticianConfig.name &&
            opticianConfig.email
            // opticianConfig.email &&
            // opticianConfig.mobile &&
            // opticianConfig.additionalComments
        ) {
            const opticianConfigCopy = { ...opticianConfig };
            setModalLoading(true);
            console.log('CLICKED THE SUBMIT BUTTON');

            if (opticianConfigCopy.mobile === '')
                opticianConfigCopy.mobile = '0';

            if (Object.keys(edit).length > 0) {
                try {
                    let { data } = await editPos({
                        ...opticianConfigCopy,
                        phoneNumber: opticianConfigCopy.mobile,
                    });
                    console.log(data);
                    if (data) {
                        setEdit({});
                        setShow(false);
                        setLoading(true);
                    }
                } catch (error) {
                    console.log(error, 'errorerror');
                } finally {
                    setModalLoading(false);
                }
            } else {
                try {
                    let { data } = await addPos({
                        ...opticianConfigCopy,
                        phoneNumber: opticianConfigCopy.mobile,
                    });
                    console.log(data);
                    if (data) {
                        setShow(false);
                        setLoading(true);
                    }
                } catch (error) {
                    console.log(error, 'errorerror');
                } finally {
                    setModalLoading(false);
                }
            }
        } else {
            const updatedStatus = { ...inputStatus };

            if (opticianConfig.name === '') updatedStatus.name = true;
            if (opticianConfig.email === '') updatedStatus.email = true;
            // if (opticianConfig.mobile === '') updatedStatus.mobile = true;
            // if (opticianConfig.additionalComments === '')
            //     updatedStatus.additionalComments = true;

            setInputStatus(updatedStatus);
        }
    };

    return (
        <>
            <Button variant="primary" onClick={() => setShow(true)}>
                <Plus width={14} height={14} />
                {t('addpos')}
            </Button>
            <Modal
                show={show}
                size="lg"
                onHide={() => {
                    setShow(false);
                    setEdit({});
                }}
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Form noValidate onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('addpos')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_form">
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('name')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={opticianConfig.name}
                                        type="text"
                                        name="name"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.name}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {/* {t('phone')} {t('isRequired')} */}
                                        Name can't be empty.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('posEmail')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={opticianConfig.email}
                                        type="text"
                                        name="email"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.email}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {/* {t('phone')} {t('isRequired')} */}
                                        Email can't be empty.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('phone')}</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={opticianConfig.mobile || 0}
                                        type="number"
                                        name="mobile"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.mobile}
                                         inputMode="numeric"
                                         pattern="[0-9]*"
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {/* {t('phone')} {t('isRequired')} */}
                                        Mobile Number can't be empty.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('Contexte')}</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={
                                            opticianConfig.additionalComments
                                        }
                                        type="text"
                                        name="additionalComments"
                                        placeholder={t('inputText')}
                                        isInvalid={
                                            inputStatus.additionalComments
                                        }
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {/* {t('phone')} {t('isRequired')} */}
                                        Coments Number can't be empty.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setShow(false);
                                setEdit({});
                            }}
                        >
                            {t('cancel')}
                        </Button>
                        {/* <Button variant="primary" type="submit">Add new sheet</Button> */}
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={modalLoading}
                        >
                            {modalLoading && (
                                <Spinner
                                    animation="border"
                                    role="status"
                                    size="sm"
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </Spinner>
                            )}{' '}
                            {t('addNewSheet')}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

export default AddPos;
